import { render, staticRenderFns } from "./RegisterPrivacyPolicy.vue?vue&type=template&id=64916829&scoped=true&"
import script from "./RegisterPrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./RegisterPrivacyPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterPrivacyPolicy.vue?vue&type=style&index=0&id=64916829&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64916829",
  null
  
)

export default component.exports